<template>
  <router-link to="/cart" class="cart">
    <i class="cart__icon icon-cart"></i>
    <span class="cart__notification">{{ cartItemCount }}</span>
  </router-link>
</template>

<script>
export default {
  name: 'CartStatusIcon',
  data () {
    return {

    }
  },
  computed: {
    cartItemCount () {
      return this.$store.state.cart.reduce((a, b) => a + b.quantity, 0)
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// CartStatusIcon.vue?c4edd216